import React from 'react';
import { array, oneOf, string } from 'prop-types';
import numeral from 'numeral';

function formatter(format, value) {
    switch (format) {
        case 'percent': {
            const unit = parseFloat(value);
            return !(isNaN(unit)) && numeral(unit).divide(100).format('0.00%');
        }
        default:
            return value;
    }
}

const DriverProperty = ({ config, format, property }) => {
    if (!config || config.length === 0) {
        return null;
    }
    return (
        <>
            {config.map((item, key) => {
                const value = formatter(format, item[property]);
                return <span key={key}>{value}</span>;
            })}
        </>
    );
};

DriverProperty.defaultProps = {
    format: 'string'
};

DriverProperty.propTypes = {
    config:   array,
    format:   oneOf(['percent', 'string']),
    property: string
};

export default DriverProperty;
